import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { PlotterMode } from 'business/data-analysis/constants';
import { useFilters } from 'business/data-analysis/pages/graph/components/filter-card/hooks/use-filters';
import { GraphSetProvider } from 'business/data-analysis/pages/graph/hooks/graph-context/provider';
import { GraphSetDataProvider } from 'business/data-analysis/pages/graph/hooks/graph-data-context/provider';
import { useMode } from 'business/data-analysis/pages/graph/hooks/use-mode';
import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { MultipleGraphReferencesContextProvider } from 'business/providers/graph-reference';
import { NoMobileSupport } from 'ui/no-mobile-support';

import { DataAnalysisMobileFilters } from './mobile-filters';
import { SingleGraphContainer } from './single-graph-container';

export const DataAnalysisMobile = () => {
  const { t } = useTranslation();
  const { filters, onChangeFilters } = useFilters(PlotterMode.TIME_PERIOD, [
    dayjs().subtract(1, 'hour'),
    dayjs(),
  ]);

  const mode = useMode();

  if (mode === PlotterMode.RING) {
    return <NoMobileSupport />;
  }

  return (
    <GraphSetDataProvider>
      <GraphSetProvider>
        <MultipleGraphReferencesContextProvider>
          <MobileSingleCardPageWithFilterLayout
            filters={
              <DataAnalysisMobileFilters
                filters={filters}
                onChangeFilters={onChangeFilters}
              />
            }
            title={t('user.menu.sections.dataAnalysis.timePeriod.title')}
          >
            <SingleGraphContainer filters={filters} />
          </MobileSingleCardPageWithFilterLayout>
        </MultipleGraphReferencesContextProvider>
      </GraphSetProvider>
    </GraphSetDataProvider>
  );
};
